import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Link,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

const SUPPORT_EMAIL = "support@blueoceansp.atlassian.net";

function buildMailto(context) {
  const subject = context
    ? `Vermost Portal Support (${context})`
    : "Vermost Portal Support";
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}

export default function SupportContactDialog({ open, onClose, context }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Contact Support</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              bgcolor: "#2563eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              mt: 0.25,
            }}
          >
            <EmailIcon sx={{ color: "white", fontSize: 18 }} />
          </Box>

          <Box>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
              Need help? Email our support team:
            </Typography>
            <Link
              href={buildMailto(context)}
              underline="hover"
              sx={{ fontSize: 14, color: "text.primary", fontWeight: 600 }}
            >
              {SUPPORT_EMAIL}
            </Link>
            <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
              Include any relevant details (username, role, and what you were trying to do) so
              we can help faster.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit" sx={{ textTransform: "none" }}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            window.location.href = buildMailto(context);
          }}
          sx={{ textTransform: "none" }}
        >
          Email Support
        </Button>
      </DialogActions>
    </Dialog>
  );
}

